import { action, computed, observable, makeObservable } from 'mobx';

import { Constructor } from 'jsx/mixins/types';

const Paginatable = <T extends Constructor>(superclass: T) => {
  class PaginatableClass extends superclass {
    @observable
    pageData = {
      currentPage: 1,
      totalPages: 1,
    };

    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
    }

    @computed
    get currentPage(): number {
      return this.pageData.currentPage;
    }

    @action
    setPage = (pageArg: string | number): void => {
      const page = typeof pageArg === 'string' ? pageArg : String(pageArg);

      this.pageData.currentPage = parseInt(page, 10);
    };

    @action
    setTotalPages = (numTotalArg: string | number): void => {
      const numTotal =
        typeof numTotalArg === 'string' ? numTotalArg : String(numTotalArg);

      this.pageData.totalPages = parseInt(numTotal, 10);
    };

    @action
    prevPage = (): void => this.setPage(this.pageData.currentPage - 1);

    @action
    nextPage = (): void => this.setPage(this.pageData.currentPage + 1);
  }

  return PaginatableClass;
};

export default Paginatable;
